// OUR MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useErrorMessagesRequest = () => {
  const getErrorMessages = async (providerId, languageId, errorHandler) => {
    try {
      const params = new URLSearchParams();
      params.append('provider_id', providerId);
      params.append('language_id', languageId);

      const url = `${
        config.baseServerURL
      }/admin/translation/error_messages?${params.toString()}`;
      const options = {
        method: 'GET',
      };
      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  };

  const getPatterns = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/translation/error_messages/patterns`;
      const options = {
        method: 'GET',
      };
      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  };

  const createErrorMessage = async (message, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/translation/error_messages`;
      const options = {
        method: 'POST',
        body: JSON.stringify(message),
        headers: {
          'Content-Type': 'application/json',
        },
      };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  };

  const updateErrorMessage = async (id, message, errorHandler) => {
    console.log(message);
    try {
      const url = `${config.baseServerURL}/admin/translation/error_messages/${id}`;
      const options = {
        method: 'PUT',
        body: JSON.stringify(message),
        headers: {
          'Content-Type': 'application/json',
        },
      };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  };
  return {
    getErrorMessages,
    getPatterns,
    updateErrorMessage,
    createErrorMessage,
  };
};

export default useErrorMessagesRequest;
